import React from "react";
import { Link } from "react-router-dom";
import { CONTACT_ADDRESS } from "./PolicyPage";
import "../css/footer.scss";

const linkGroups = [
  {
    title: "Customer care",
    links: [
      ["Shipping & delivery", "/shipping"],
      ["Returns & refunds", "/returns"],
      ["Orders & cancellations", "/orders"],
      ["Payments & billing", "/payments"],
      ["Jewelry care & warranty", "/warranty-care"],
      ["FAQs", "/faqs"],
    ],
  },
  {
    title: "Privacy & terms",
    links: [
      ["Privacy policy", "/privacy"],
      ["Privacy choices", "/privacy-choices"],
      ["Cookie policy", "/cookies"],
      ["Terms of service", "/terms"],
      ["Consumer rights", "/consumer-rights"],
      ["Acceptable use", "/acceptable-use"],
    ],
  },
  {
    title: "Information",
    links: [
      ["Product information", "/product-policy"],
      ["Promotions & gift cards", "/promotions"],
      ["Security & fraud", "/security"],
      ["Marketing communications", "/communications"],
      ["Intellectual property", "/intellectual-property"],
      ["Accessibility", "/accessibility"],
    ],
  },
  {
    title: "Support",
    links: [
      ["Policy center", "/policies"],
      ["Complaints & disputes", "/complaints"],
      ["Contact us", "/contact"],
    ],
  },
];

function Footer() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-links">
          {linkGroups.map((group) => (
            <div className="footer-column" key={group.title}>
              <h4>{group.title}</h4>
              {group.links.map(([label, path]) => (
                <Link to={path} onClick={toTop} key={path}>
                  {label}
                </Link>
              ))}
              {group.title === "Support" && (
                <>
                  <a href="mailto:kit@sacuddin.shop">kit@sacuddin.shop</a>
                  <address className="footer-address">{CONTACT_ADDRESS}</address>
                </>
              )}
            </div>
          ))}
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>© Sacuddin 2026</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
